import { configureStore } from '@reduxjs/toolkit';
import alertsReducer from './alertsSlice';
import userReducer from './userSlice'

export default configureStore({
  reducer: {
    alerts: alertsReducer
    , user: userReducer
  }
})